/**
 * Created by Jie Gao on 2018-11-07.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetLineWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {IPolyBetLineConfig, PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {StarStruckParsedGameData} from "../server/data/StarStruckParsedGameData";
import {StarStruckGameConfig} from "../StarStruckGameConfig";
import {StarStruckBetlineEvent} from "./StarStruckBetlineEvent";
import BitmapText = PIXI.BitmapText;

export class StarStruckBetline extends PolyBetLine {
    private _betlineData:IBetWinData[];
    private _winAmount:BitmapText;
    private _winMultiplier:BitmapText;
    private _y:number[] = [340, 195, 485, 340, 340];

    constructor(index:number, numberPosition:number[], betLineData:number[], config:IPolyBetLineConfig) {
        super(index, numberPosition, betLineData, config);
        this.addMultiplierEventListeners();
        this._winAmount = new BitmapText("0", {
            fontName : "NumbersWinCountUp",
            fontSize : 20
        });

        this._winMultiplier = new BitmapText("0", {
            fontName : "NumbersWinMultiplier",
            fontSize : 14
        });
        this._winAmount.visible = false;
        this._winMultiplier.visible = false;
        this.addChild(this._winAmount);
        this.addChild(this._winMultiplier);

        this._winAmount.x = StarStruckGameConfig.instance.GAME_WIDTH / 2;
        this._winAmount.y = this._y[index - 1] - this._winAmount.height / 2 + 3;
        this._winMultiplier.x = StarStruckGameConfig.instance.GAME_WIDTH / 2;
        this._winMultiplier.y = this._y[index - 1] - this._winMultiplier.height / 2;

        this.addFeatureEventListeners();
    }

    private addFeatureEventListeners():void {
        EventHandler.addEventListener(this, StarStruckBetlineEvent.SHOW_WIN_BET_LINE_WINS, (event:GameEvent) => this.onShowWinBetLineWin(event.params[0]));
    }

    private addMultiplierEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.parsedGameData(event.params[0]));
    }

    private parsedGameData(data:StarStruckParsedGameData):void {
        this._betlineData = data.betWins;
    }

    private onShowWinBetLineWin(index:number):void {
        if(index !== this.index) {
            return;
        }

        this.showWin(true);
    }

    protected showStatic():void {
        this.showWin(false);
    }

    protected draw(numberPosition:number[], betLineData:number[], config:IPolyBetLineConfig):void {
        const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("betline_" + this.index)[0]);
        sprite.anchor.set(0, 0);
        sprite.x = StarStruckGameConfig.instance.REEL_AREA_POS_X - 15;
        sprite.y = 2;
        this.addChild(sprite);
        StageManager.getLayer(config.staticLineLayer).addChild(this);
        this.alpha = 0;
    }

    protected showWin(withWinAmount:boolean = false):void {
        super.showWin();

        const id:number = this.index;
        this._winAmount.visible = false;
        this._winMultiplier.visible = false;
        if(!withWinAmount) {
            return;
        }
        (<IBetLineWinData[]>this._betlineData).forEach((data:IBetLineWinData) => {
            //data.betLineIndex === id &&
            if(data.betLineIndex === (id - 1)) {
                this._winAmount.visible = true;
                this._winAmount.text = (data.amount.toFixed(2)).toString();
                this._winAmount.x = Helper.getSymbolPositions(1, 1)[0] - this._winAmount.width / 2;

                if(data.multiplier > 1) {
                    this._winAmount.x = Helper.getSymbolPositions(1, 1)[0] - this._winAmount.width;
                    this._winMultiplier.visible = true;
                    this._winMultiplier.text = (" X" + data.multiplier).toString();
                    this._winMultiplier.x = Helper.getSymbolPositions(1, 1)[0];
                } else {
                    this._winMultiplier.visible = false;
                    this._winMultiplier.text = "";
                }
                this._winAmount.x = Helper.getSymbolPositions(1, 1)[0] - (this._winAmount.width + this._winMultiplier.width) / 2;
                this._winMultiplier.x = this._winAmount.x + this._winAmount.width;
            }
        });
    }
}